<template>
  <div class="avue-sidebar">
    <logo></logo>
    <el-row class="tac">
      <el-col :span="24" style="height: 100%">
        <div style="overflow: scroll; height: 100%; overflow-x: hidden">
          <el-menu
              :collapse="keyCollapse"
              class="el-menu-vertical-demo"
              :default-active="accessMenuId"
              text-color="#fff"
              unique-opened
              @close="handleClose"
              @open="handleOpen"
          >
            <el-submenu v-for="item in menu" v-if="item.children.length!=0" :key="item.id" :index="item.id">
              <template slot="title">
                <!--                <img :src="img[item.source]" alt="loading" class="svg-img">-->
                <i class="el-icon-collection"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group>
                <el-submenu v-for="(item1,index) in item.children " v-if="item1.children.length!=0" :key="item.id+index"
                            :index="item1.id">
                  <template slot="title">
                    <span>{{ item1.name }}</span>
                  </template>
                  <el-menu-item-group>
                    <el-submenu v-for="item2 in item1.children" v-if="item2.children.length!=0" :key="item2.id"
                                :index="item2.id">
                      <template slot="title">
                        <span>{{ item2.name }}</span>
                      </template>
                      <el-menu-item-group>
                        <template slot="title"></template>
                        <el-menu-item
                            v-for=" item3 in item2.children"
                            :key="item3.id"
                            :index="item3.path"
                            @click="next(item3.path)"
                        > {{ item3.name }}
                        </el-menu-item
                        >
                      </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item
                        v-else
                        :index="item2.path"
                        @click="next(item2.path)"
                    > {{ item2.name }}
                    </el-menu-item
                    >
                  </el-menu-item-group>
                </el-submenu>
                <el-menu-item
                    v-else
                    :index="item1.path"
                    @click="next(item1.path)"
                > {{ item1.name }}
                </el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item
                v-else
                :index="item.path"
                @click="next(item.path)"
            >
              <!--              <img :src="img[item.source]" alt="">-->
              <i class="el-icon-collection"></i>
              <span>{{ item.name }}</span>
            </el-menu-item
            >
          </el-menu>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import logo from "../logo";
import { mapGetters } from "vuex";
export default {
  name: "sidebar",

  data() {
    return {
      img: {
        // home: require('../../../assets/images/首页.svg'),
        // caseAdministration: require('../../../assets/images/案件管理.svg'),
        // resourceManagement: require('../../../assets/images/法律资源.svg'),
        // complianceManagement: require('../../../assets/images/证券合规.svg'),
        // systemManagement: require('../../../assets/images/系统管理.svg'),
      }

    };
  },
  components: {
    logo,

  },
  created() {},
  computed: {
    ...mapGetters(["tagWel", "tagList", "tag", "menu", "accessMenuId", "isCollapse", "keyCollapse"]),
  },
  mounted() {},
  methods: {
    open(item) {
      // 清空起草的缓存数据
      window.sessionStorage.removeItem("draftForm");
    },
    next(address, name) {
      const key = {
        value: address,
        label: name,
      };
      this.open(key);
      this.$router.push(address).catch(() => {});
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-menu-vertical-demo {
  text-align: left;
}

.el-submenu__icon-arrow {
  right: 10px;
}

::v-deep .el-submenu__title:hover {
  background: #ffffff !important;
  color: #000000 !important;
}

::v-deep .el-submenu__title:hover span {
  color: #000000 !important;
}

::v-deep .el-submenu__title:hover img {
  color: #000000 !important;
}

::v-deep .el-submenu__title:hover i {
  color: #000000 !important;
}

::v-deep .el-menu-item {
  &.is-active:before {
    background: #409eff !important;
    color: #000000;
  }

  &.is-active {
    background: #fff !important;
  }

  &.is-active span {
    color: #000 !important;
  }

  &.is-active i {
    color: #000 !important;
  }

  span {
    color: rgba(255, 255, 255, 1) !important;
  }

  i {
    color: rgba(255, 255, 255, 1) !important;
  }
}

.tac {
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

::v-deep .el-submenu__title {
  font-weight: 800 !important;
  color: rgb(255, 255, 255);

  img {
    color: rgba(255, 255, 255, 1) !important;
  }

  span {
    color: rgba(255, 255, 255, 1) !important;
  }

  i {
    color: rgba(255, 255, 255, 1) !important;
  }
}

img {
  color: #000000 !important;
  margin-right: 5px;
  height: 20px;
  width: 20px;
}
</style>

